<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <span
        v-if="currentLocale.flag"
        class="flag ff-md current-flag"
        :class="currentLocale.flag"
      />
      <span class="ml-50 font-weight-bold text-body">{{ currentLocale.name }}</span>
    </template>
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >

      <b-dropdown-item
        v-for="localeObj in locales"
        :key="localeObj.id"
        @click="setLocale(localeObj)"
      >
        <span
          class="flag ff-md list-flag"
          :class="localeObj.flag"
        />
        <span class="ml-50 font-weight-semi-bold">{{ localeObj.name }}</span>
      </b-dropdown-item>
    </vue-perfect-scrollbar>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem } from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import LocalizationService from '@/services/localization-service'
import ALL_LOCALES from '@/constants/locales'

export default {
  components: {
    VuePerfectScrollbar,
    BNavItemDropdown,
    BDropdownItem,
  },
  data() {
    return {
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
    }
  },
  computed: {
    currentLocale() {
      return this.locales.find(l => l.id === this.$i18n.locale) ?? { id: this.$i18n.locale, flag: '', name: this.$i18n.locale }
    },
    locales() {
      return ALL_LOCALES
    },
  },
  methods: {
    setLocale(localeObj) {
      if (localeObj?.id !== this.$i18n.locale) {
        LocalizationService.setLocale(localeObj.id)
      }
    },
  },
}
</script>

<style lang="scss">
.dropdown-language {

}
</style>
